import {DestroyRef, inject, provideAppInitializer} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Actions, ofActionCompleted, Store} from '@ngxs/store';
import {RouterNavigated} from '@ngxs/router-plugin';
import {map, switchMap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DashboardStateModel, defaultState} from '../../dashboard/+state/dashboard-state.model';
import {ToggleDashboardFeature} from '../../dashboard/+state/actions';

const getLayoutData = (snapshot: ActivatedRouteSnapshot) => {
  const {children} = snapshot;
  if (children.length > 0) {
    return getLayoutData(children[0]);
  }
  return (snapshot.data['layout'] ?? defaultState) as Partial<DashboardStateModel>;
}

const layoutInit = (actions: Actions, store: Store, destroyRef: DestroyRef) => {
  actions.pipe(
    ofActionCompleted(RouterNavigated<ActivatedRouteSnapshot>),
    map(({action: {routerState: {root: data}}}) => getLayoutData(data)),
    switchMap(data => store.dispatch(new ToggleDashboardFeature(data))),
    takeUntilDestroyed(destroyRef)
  ).subscribe();
}

export const provideLayoutStateListener = provideAppInitializer(() => {
  const actions = inject(Actions);
  const store = inject(Store);
  const destroyRef = inject(DestroyRef);

  return layoutInit(actions, store, destroyRef);
});
